export default __webpack_public_path__ + "static/media/Autopilot.65233197.gif";